<div style="width: 300px;text-align: center;">
   
    <div style="    padding-bottom: 10px;"> 
        <span style="font-weight: bold;"> Contact us:</span> <br>

    </div>
    <img src="../assets/email.png" width="18px" height="18px"  >
    <!-- <span class="headStyle">&nbsp;&nbsp;&nbsp; Email:</span> -->
    <span> &nbsp; contact@vaadude.com</span>  <br>
    <!-- <span  class="headStyle">&nbsp;&nbsp;&nbsp; Twitter: </span> -->
    <img src="../assets/twitter.svg" width="18px" height="18px"  >

    <span> &nbsp;vaadude_getIT</span> <br> 
    <!-- <span  class="headStyle">&nbsp;&nbsp;&nbsp; Instagram: </span> -->
    <img src="../assets/instagram.png" width="18px" height="18px"  >

    <span> &nbsp;vaadude_getIT</span> <br>
	
	
	
</div>
<div style="width: 300px;display: flex;justify-content: end;margin-top: 10px;"  >
        <button style="background-color: #2265f3;color: white;padding: 0px 5px;border: solid 2px #2265f3;
        border-radius: 5px;" (click)="closePopup()">close</button>
</div>